// Angular
import {Routes} from '@angular/router';

// App guards
import {productFeatureSessionGuard} from '@app/core/guards/product-feature-session.guard';
import {SystemGuard} from '@shared/guards/system.guard';

// App components
import {C404Component} from '@shared/components/c404/c404.component';
import {MaintenanceComponent} from '@shared/components/maintenance/maintenance.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.routes),
  },
  {
    path: 'purpose',
    redirectTo: 'auth/purpose',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [SystemGuard, productFeatureSessionGuard],
    loadChildren: () => import('./main/main.routes').then(m => m.routes),
  },
  {path: '404', component: C404Component},
  {path: 'maintenance', component: MaintenanceComponent},
  {path: '**', redirectTo: '404', pathMatch: 'full'},
];
